module.exports = __webpack_public_path__ + "static/IMG_0162-2b5e8e2fd90be41c7d0f8455ac2d1c13.png";